import { memo } from 'react';
import type { CellProps } from 'react-table';
import ClickContainer from './ResultClickContainer';
import type { TranscriptsTableItem } from './interfaces';
import styles from './style/Cell.Name.module.css';
import TranscriptFileIcon from '@trinity/chat-components/components/icons/File/Transcript.js';

export const Name = memo(({ row: { original: data } }: CellProps<TranscriptsTableItem>) => {

  return (
    <ClickContainer item={data} className={styles.overflowWrapper}>
      <div className={styles.root}>
        <TranscriptFileIcon
          className={styles.videoCallIcon}
          size={26} />
        <div className={styles.name}>{data.name}</div>
      </div>
    </ClickContainer>
  );
});

export default Name;